module.exports = __webpack_public_path__ + "static/media/finalizar.1e803ccd.svg";